import { getGlobalParamsOptionsAsync } from '@/utils/common.js'

export const searchFormConfig = {
  formItems: [
    {
      field: 'taskType',
      type: 'select',
      label: 'terminal.task-type',
      options: [],
      isResolveGlobalParams: true,
      handler: () =>
        getGlobalParamsOptionsAsync('switchTypeList', {
          isNeedPreFix: false
        })
    },
    {
      field: 'status',
      type: 'select',
      label: 'general.status',
      options: [],
      isResolveGlobalParams: true,
      handler: () =>
        getGlobalParamsOptionsAsync('switchStatusList', {
          isNeedPreFix: false
        }),
      otherOptions: {}
    },
    {
      field: 'creationDate',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
